import React, { Suspense } from 'react';

/**
 * @example simple usage
 * const Heading = withSuspense(
 *   Rect.lazy(() => import('../Atoms/Heading/Heading')),
 *   null
 * );
 *
 * @example usage with fallback
 * const Heading = withSuspense(
 *   Rect.lazy(() => import('../Atoms/Heading/Heading')),
 *   Loading
 * );
 *
 * @example custom fallback consumer
 * const LazyLoadedComponent = withSuspense(Rect.lazy(() => import('../Component')), null);
 * <LazyLoadedComponent suspenseFallback={<div styles={{ width: '100px', height: '50px' }} />} />
 */
export function withSuspense(LazyLoadedComponent, Fallback = null) {
  return props => (
    <Suspense fallback={props.suspenseFallback || (Fallback && <Fallback />)}>
      <LazyLoadedComponent {...props} />
    </Suspense>
  );
}
